import React, { useState, memo, useEffect } from "react";

/**
 * TransportLogo Component
 * requirement (แบบ A): ถ้าโหลดรูปไม่ได้ ให้ "ไม่แสดงรูป" แต่คงพื้นที่ไว้ (กัน layout กระโดด)
 *
 * ✅ แยกออกมาเป็น top-level component ตาม Vercel best practice:
 *    rerender-no-inline-components — ห้าม define component ภายใน component อื่น
 */
interface TransportLogoProps {
  src?: string | null;
  alt: string;
  height: number;
  width: number;
}

const TransportLogo: React.FC<TransportLogoProps> = memo(({ src, alt, height, width }) => {
  const [broken, setBroken] = useState(false);

  // ✅ Fix: reset broken state เมื่อ src เปลี่ยน
  // ก่อนหน้านี้ ถ้า src แรกโหลดไม่สำเร็จ → broken=true → แม้ src จะเปลี่ยนเป็น URL ใหม่ที่โหลดได้
  // broken ก็ยังค้างเป็น true ทำให้ render <div /> ว่างตลอด (logo หายเมื่อสลับขนส่ง)
  useEffect(() => {
    setBroken(false);
  }, [src]);

  if (!src || broken) {
    return <div style={{ height, width }} />;
  }

  return (
    <img
      src={src}
      alt={alt}
      style={{ height, width, objectFit: "contain" }}
      loading="lazy"
      onError={() => setBroken(true)}
    />
  );
});

TransportLogo.displayName = "TransportLogo";

export default TransportLogo;
